<!--诗歌-->
<template>
  <div
    :class="{
      view26Wrapper: true,
      cardWidth: true,
    
    }"
  >
    <div class="v26Content">
      <PoetryContent :data="list[0]"></PoetryContent>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import PoetryContent from "../Use/poetry-content";
export default {
  name: "View26",
  components: { PoetryContent },
  props: {
    list: {
      type: Array,
      default: [],
    },
    buttonType: {
      type: String,
      default: "default", //noBg  单个点击换一换类
    },
  },
  computed: {
    ...mapState(["shareShowData"]),
  },
  created() {
 
    let shareShowData = this.list[0];
    this.setShowShareData(shareShowData);
    this.setshareId(39);
  },
  data() {
    return {
      tempList: [{ title: "" }],
    };
  },
  methods: {
    ...mapMutations(["setShowShareData", "setshareId"]),

    onAction(type, id, name, value) {
      this.$emit("on-action", type, id, name, value);
    },
  },
  destroyed(){
    this.setShowShareData({});
  }
};
</script>
<style lang="less" >
.defaultWidth {
  width: 8rem;
}
.view26Wrapper {
 
  .v26Content {
    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
    background: url("https://dcdn.thecover.cn/robot/poertryBg.png");
    width: 8.426667rem;
    min-height: 6.733333rem;
    max-height: 11.733333rem;
    background-size: 100% 100%;
    background-position: top;
    color: #191919;
    font-size: 0.4rem;
    margin-left: 0.433333rem;
    position: relative;
    .data-conent{
          padding-top:.746667rem;
           overflow: scroll;
             .top_item {
               height: 90%;
                   min-height: 4.8rem;
             }
            .bottom_item {
              margin-top: 0.5rem;
              margin-bottom: 0.2rem;
            }
 
    }
  }
}
</style>
